import { useState, useEffect } from 'react';

export const useSidebarState = () => {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('decoded_sidebar_collapsed') === 'true';
  });

  useEffect(() => {
    const handleSidebarToggle = (event) => {
      setCollapsed(event.detail.collapsed);
    };

    window.addEventListener('sidebarToggle', handleSidebarToggle);
    return () => window.removeEventListener('sidebarToggle', handleSidebarToggle);
  }, []);

  return collapsed;
};

// CSS class helper for main content
export const getMainContentClass = (collapsed) => {
  return collapsed ? 'lg:ml-20' : 'lg:ml-72';
};

export default useSidebarState;
